import { useState } from 'react';

import type { MediaPlan } from '@mint-sdk/api-media-plan';

import { DeleteMediaDataContext } from '../../../../../../hooks/useSetMediaDataToDelete.js';
import { DeleteMediaDataModal } from './DeleteMediaDataModal.jsx';

type DeleteMediaDataProviderProps = {
  children: React.ReactNode;
};

export const DeleteMediaDataProvider = ({
  children,
}: DeleteMediaDataProviderProps) => {
  const [mediaDataToDelete, setMediaDataToDelete] =
    useState<MediaPlan.MediaData | null>(null);

  return (
    <DeleteMediaDataContext.Provider value={setMediaDataToDelete}>
      {children}
      <DeleteMediaDataModal
        mediaData={mediaDataToDelete}
        onClose={() => setMediaDataToDelete(null)}
      />
    </DeleteMediaDataContext.Provider>
  );
};
